var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "attr.list",
    title: "List",
    description: "Validates that the field value matches one of the predefined list values. Supports strict `must` enforcement or soft `suggest` options. Case sensitivity is configurable.",
    type: "attribute",
    use: {
        namespace: "ua.fields.schema.editor"
    },
    fields: {
        must: {
            title: "Must Match",
            type: "list",
            of: "any",
            description: "An array of values that the field value must match. If the field value does not match any of these values, an error is thrown."
        },
        suggest: {
            title: "Suggest Values",
            type: "list",
            of: "any",
            description: "An array of values that the field value can match. If the field value does not match any of these values, it is still considered valid, but a warning is issued."
        },
        caseSensitive: {
            title: "Case Sensitive",
            type: "boolean",
            default: false,
            description: "If true, the field value must match the case of the values in `must` or `suggest`. If false, the comparison is case-insensitive."
        }
    },
    tests: {
        validString: {
            must: true,
            run: function () {
                return validate({ list: { must: ["icon1", "icon2"] } }, "icon1");
            }
        },
        validStringInsensitive: {
            must: true,
            run: function () {
                return validate({ list: { must: ["Icon1", "Icon2"], caseSensitive: false } }, "icon1");
            }
        },
        invalidString: {
            throw: "fields.attr.list.invalid",
            run: function () {
                return validate({ list: { must: ["a", "b", "c"] } }, "d");
            }
        },
        validArray: {
            must: true,
            run: function () {
                return validate({ list: { must: ["x", "y", "z"] } }, ["x", "z"]);
            }
        },
        invalidArray: {
            throw: "fields.attr.list.invalid",
            run: function () {
                return validate({ list: { must: ["one", "two"] } }, ["one", "three"]);
            }
        },
        validObject: {
            must: true,
            run: function () {
                return validate({ list: { must: [{ a: 1 }, { b: 2 }] } }, { b: 2 });
            }
        },
        invalidObject: {
            throw: "fields.attr.list.invalid",
            run: function () {
                return validate({ list: { must: [{ a: 1 }] } }, { b: 2 });
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid List Value",
            description: "The value provided does not match any of the allowed items defined in list.must.",
            template: "The value '${value}' is not allowed. Allowed values: ${allowed}."
        }
    }
});

function validate(spec, value) {

    //is their a spec.list
    if ("list" in spec) {
        //is it an array? than it must be a list.must
        if (Array.isArray(spec.list)) {
            spec.list = { must: spec.list };
        }
    }

    if (!spec || !spec.list || !spec.list.must) return;

    var list = spec.list.must;
    var caseSensitive = spec.list.caseSensitive === true;

    function normalize(val) {
        return (typeof val === "string" && !caseSensitive) ? val.toLowerCase() : val;
    }

    var allowed = {};
    var i;
    if (Array.isArray(list)) {
        for (i = 0; i < list.length; i++) {
            allowed[JSON.stringify(normalize(list[i]))] = true;
        }
    } else {
        allowed[JSON.stringify(normalize(list))] = true;
    }

    function isAllowed(val) {
        return allowed.hasOwnProperty(JSON.stringify(normalize(val)));
    }

    if (Array.isArray(value)) {
        for (i = 0; i < value.length; i++) {
            if (!isAllowed(value[i])) {
                _.errors.invalid.throw({ value: value[i], allowed: list.join(", ") });
            }
        }
    } else if (typeof value === "object" && value !== null) {
        var found = false;
        for (i = 0; i < list.length; i++) {
            if (typeof list[i] === "object" && JSON.stringify(list[i]) === JSON.stringify(value)) {
                found = true;
                break;
            }
        }
        if (!found) {
            _.errors.invalid.throw({ value: JSON.stringify(value), allowed: JSON.stringify(list) });
        }
    } else {
        if (!isAllowed(value)) {
            _.errors.invalid.throw({ value: value, allowed: list.join(", ") });
        }
    }
}

module.exports.validate = validate;
